import MinimalLayout from 'layout/MinimalLayout';
import Login from 'pages/authentication/Login';

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Login />
    },
  ]
};

export default LoginRoutes;
